module.exports = __webpack_public_path__ + "static/media/1_en.0c40eef3.png";